/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface BasicPostProcessing
 */
export interface BasicPostProcessing {
  /**
   *
   */
  readonly simulation?: string;
  /**
   * Scenario name for saving the results
   */
  scenarioName?: string;
  /**
   *
   */
  processBasicResults?: boolean;
  /**
   *
   */
  resultUuid?: string;
}

/**
 * Check if a given object implements the BasicPostProcessing interface.
 */
export function instanceOfBasicPostProcessing(value: object): value is BasicPostProcessing {
  return true;
}

export function BasicPostProcessingFromJSON(json: any): BasicPostProcessing {
  return BasicPostProcessingFromJSONTyped(json, false);
}

export function BasicPostProcessingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BasicPostProcessing {
  if (json == null) {
    return json;
  }
  return {
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    scenarioName: json["scenario_name"] == null ? undefined : json["scenario_name"],
    processBasicResults:
      json["process_basic_results"] == null ? undefined : json["process_basic_results"],
    resultUuid: json["result_uuid"] == null ? undefined : json["result_uuid"],
  };
}

export function BasicPostProcessingToJSON(json: any): BasicPostProcessing {
  return BasicPostProcessingToJSONTyped(json, false);
}

export function BasicPostProcessingToJSONTyped(
  value?: Omit<BasicPostProcessing, "simulation"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    scenario_name: value["scenarioName"],
    process_basic_results: value["processBasicResults"],
    result_uuid: value["resultUuid"],
  };
}
